module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/缺省插图-无搜索结果.1c545.png";